var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gts",style:({ transform: ("rotate(" + (_vm.getPlayerDistanceInDeg()) + "deg)") })},[_c('div',{staticClass:"gts__inner",style:({
      transform: ("translate(-50%, -50%) rotate(-" + (_vm.getPlayerDistanceInDeg()) + "deg)"),
    })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }